import React, { useEffect, useState } from "react";
import Factory1 from "../../assets/framework.jpg";
import Factory2 from "../../assets/support.jpg";

const TestimonialsSlider = () => {
  const slides = [
    {
      quote:
        "We now have a framework and disciplined approach for solving problems. As a result of your workshop and the implementation of this approach, our external product problem has been completely eliminated. Our PPMs have been reduced to 0 for four consecutive months. Since May, we have reduced our internal scrap by 30%.",
      title: "VP Operations",
      org: "Fortune 500 Manufacturer",
      image: Factory1
    },
    {
      quote:
        "Your training and ongoing support of projects have led to deeper engagement of the teams and the development of strong problem-solving abilities. I believe the skills and tools they've gained from this project will follow the team members as they move on to new projects.",
      title: "Product Design Leader",
      org: "Global Automotive Supplier",
      image: Factory2
    }
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 7000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="w-full bg-[color:var(--surface)]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="flex flex-col gap-3 max-w-2xl">
          <span className="inline-flex w-fit items-center rounded-full bg-[color:var(--brand)]/10 px-4 py-2 text-sm font-semibold text-[color:var(--brand)]">
            Client Impact
          </span>
          <h2 className="text-2xl sm:text-3xl font-semibold text-[color:var(--navy)]">
            Proven results from real teams
          </h2>
          <p className="text-[color:var(--muted)]">
            Outcomes driven by structured problem-solving and disciplined execution.
          </p>
        </div>

        <div className="mt-12 relative overflow-hidden rounded-xl border border-[color:var(--border)] bg-white shadow-lg">
          <div
            className="flex transition-transform duration-700 ease-in-out"
            style={{ transform: `translateX(-${index * 100}%)` }}
          >
            {slides.map((s, i) => (
              <div key={i} className="min-w-full grid lg:grid-cols-2">
                <div className="relative h-72 lg:h-full">
                  <img
                    src={s.image}
                    alt=""
                    className="h-full w-full object-cover"
                  />
                  <div className="absolute inset-0 bg-[color:var(--navy)]/55" />
                </div>

                <div className="relative flex flex-col justify-center p-8 lg:p-12">
                  <div className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-[color:var(--brand-accent)]/15 blur-3xl" />
                  <div className="absolute -bottom-16 -left-16 h-48 w-48 rounded-full bg-[color:var(--brand)]/10 blur-3xl" />

                  <p className="relative text-base sm:text-lg leading-relaxed text-[color:var(--navy)]">
                    “{s.quote}”
                  </p>

                  <div className="relative mt-8 border-t border-[color:var(--border)] pt-4">
                    <div className="text-sm font-semibold text-[color:var(--navy)]">
                      {s.title}
                    </div>
                    <div className="text-sm text-[color:var(--muted)]">
                      {s.org}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2">
            {slides.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                className={`h-2.5 w-2.5 rounded-full transition ${
                  index === i
                    ? "bg-[color:var(--brand)]"
                    : "bg-[color:var(--border)]"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSlider;
